import React, { useState, useEffect } from "react";
import BMWLogo from "../../assets/images/BMWLogo.png";
import Car from "../../assets/images/LoadCar.png";
import QRCode from "../../assets/images/QR.png";
import { trackMobileScreenShown } from "../../utils/gtmEvents";

const MobileOnlyScreen = () => {
    const [windowSize, setWindowSize] = useState({
        width: typeof window !== 'undefined' ? window.innerWidth : 0,
        height: typeof window !== 'undefined' ? window.innerHeight : 0
    });

    // Handle window resize
    useEffect(() => {
        // Track screen view on mount
        trackMobileScreenShown();

        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Get responsive car width based on screen size
    const getCarWidth = () => {
        if (windowSize.width >= 400 && windowSize.width <= 450 && windowSize.height >= 900) {
            return '600px';
        }
        if (windowSize.width <= 400) {
            return '515px';
        }
        return '515px';
    };

    return (
        <div
            className="flex flex-col items-center justify-center h-screen w-full 
  bg-gradient-to-b from-[#010e2a] via-[#163c5b] to-[#5ba9dc] 
  relative overflow-hidden 
  px-4 sm:px-6 md:px-8 
  py-2 sm:py-4"
        >
            <div className="relative w-full h-full flex flex-col items-center justify-center px-2 sm:px-4 overflow-hidden">
                {/* Car Image - Behind everything with 3% opacity */}
                <div
                    className="absolute 
          bottom-[8vh] sm:bottom-[10vh] md:bottom-[12vh] 
          left-[74%] md:left-1/2 -translate-x-1/2 
          z-0"
                    style={{ opacity: 0.03 }}
                >
                    <img
                        src={Car}
                        alt="BMW Car"
                        className="object-contain h-auto"
                        style={{
                            width: getCarWidth()
                        }}
                    />
                </div>

                {/* Content */}
                <div className="flex flex-col items-center justify-center w-full relative z-10 max-w-3xl">
                    {/* BMW Logo */}
                    <img
                        src={BMWLogo}
                        alt="BMW Logo"
                        className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 object-contain mb-3 sm:mb-4"
                    />

                    {/* Title */}
                    <h2 className="text-white text-base sm:text-lg md:text-xl lg:text-2xl font-bmw font-light tracking-wide text-center mb-2 sm:mb-3">
                        Mobile Experience Only
                    </h2>

                    {/* Description */}
                    <p className="text-white text-xs sm:text-sm md:text-base font-bmw font-light text-center mb-3 sm:mb-4 px-4">
                        This BMW configurator is optimized for mobile devices.
                    </p>

                    {/* Instructions Box */}
                    <div className="bg-white/10 backdrop-blur-sm rounded-lg p-2.5 sm:p-3 md:p-4 mb-3 sm:mb-4 w-full max-w-md">
                        <p className="text-white text-[10px] sm:text-xs md:text-sm font-bmw font-light mb-1.5 sm:mb-2 text-center">
                            To experience the full interactive 3D configurator:
                        </p>
                        <ul className="text-white text-[10px] sm:text-xs md:text-sm font-bmw font-light space-y-1 text-left">
                            <li className="flex items-start">
                                <span className="text-[#5ba9dc] mr-1.5 flex-shrink-0">•</span>
                                <span>Scan the QR code below</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#5ba9dc] mr-1.5 flex-shrink-0">•</span>
                                <span>Or visit: https://yourbmwx3.com/</span>
                            </li>
                        </ul>
                    </div>

                    {/* QR Code */}
                    <div className="bg-white p-2 sm:p-2.5 rounded-lg shadow-lg mb-2 sm:mb-3">
                        <img
                            src={QRCode}
                            alt="QR Code"
                            className="w-20 h-20 sm:w-28 sm:h-28 md:w-32 md:h-32 object-contain"
                        />
                    </div>

                    {/* Mobile Icon */}
                    <div className="w-8 h-8 sm:w-10 sm:h-10 mx-auto">
                        <svg
                            className="w-full h-full text-white opacity-60"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileOnlyScreen;
